'use strict';

var React = require('react');
var Border = require('../common/Border');
var assetsHelper = require('../../helper/assetsHelper');
var styleHelper = require('../../helper/styleHelper');
var appTypes = require('../../types/appTypes');
var propConst = require('../../constants/propConst');
var ColorImage = require('../common/ColorImage');

var SearchBox = React.createClass({
  render: function () {
    var h = styleHelper.getHeight(this.props);
    var state = styleHelper.getPropertyValue(this.props, propConst.STATUS);
    if(!state){
      state = this.props.state;
    }
    var isDisable = state === appTypes.ComStatus1.DISABLED;
    var imgStyle = {
      position: 'absolute',
      left: 8,
      top: h / 2 - 8,
      width: 16,
      height: 16,
      whiteSpace: 'nowrap'
    };

    var borderStyle = styleHelper.StyleUtil(this.props).background().size().border().text().lineHeight().align().base().style;
    borderStyle.borderRadius = h / 2;
    if(isDisable){
      borderStyle.color = borderStyle.borderColor = appTypes.Color.MODEL_DISABLE;
    }
    return (<div className="border" style={borderStyle}>
      <ColorImage style={imgStyle}
                  color={isDisable?appTypes.Color.MODEL_DISABLE:styleHelper.getBorderColor(this.props)}
           src={assetsHelper.getComponentAsset('Search')}
      />
      <label>{styleHelper.getText(this.props)}</label>
    </div>);
  }
});

module.exports = SearchBox;



// WEBPACK FOOTER //
// ./src/views/Components/SearchBox.jsx